// extracted by mini-css-extract-plugin
export default {"body-1":"uAp9tBDNvm6F7Wgi7LEs","body-2":"i3QOuHNkXv33wv0fdibI","body-3":"CKJxojVEA9kRHXydUE3a","ant-typography":"PGwGNClhbZkRE09H6boW","text":"yAgFhRHXS859L4DWI1px"};